import { Button, LegacyCard, Page, LegacyStack, Card } from '@shopify/polaris';
import { useContext, useMemo, useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { getTransfersList, postTransfers } from '../../../services/transfersService';
import { NewTransferModal } from '../../UI/Transfers/NewTransferModal';
import ListTransfers from '../../UI/Transfers/ListTransfers';
import { checkPermission } from '../../../services/permissionsService';
import FiltersTransfers from '../../UI/Transfers/FiltersTransfers';
import { useHistory } from 'react-router';
import { getSearchParams, handleSearchParams } from '../../../helpers/handleSearchParams';
import { useQuery } from 'react-query';

const Transfers = () => {
  const [, dispatchToast] = useContext(ToastContext);

  const navigate = useHistory();

  const [currentFilters, setCurrentFilters] = useState(() => {
    const params = {
      originId: getSearchParams('originId') || undefined,
      destinationId: getSearchParams('destinationId') || undefined,
      states: getSearchParams('states') || undefined,
      s: getSearchParams('s') || '',
      page: getSearchParams('page') || 1,
    };

    return Object.keys(params).reduce((acc, k) => {
      if (params[k]) acc[k] = params[k];
      return acc;
    }, {});
  });

  const { data, isLoading, error } = useQuery(['transfers', currentFilters], () =>
    getTransfersList({
      ...currentFilters,
      limit: 30,
    }).then((r) => r.data),
  );

  const [transfers, metadata] = useMemo(() => {
    if (!data) return [[], {}, 0];
    return [data.data, data.metadata, data.metadata.count || 0];
  }, [data]);

  const handleFilter = ({ slug, value }) => {
    handleSearchParams(slug, value);
    if (slug !== 'page') handleSearchParams('page', 1);
    setCurrentFilters((prev) => {
      const params = slug === 'page'
        ? { ...prev, page: value }
        : { ...prev, [slug]: value || null, page: 1 };
      return Object.keys(params).reduce((acc, k) => {
        if (params[k]) acc[k] = params[k];
        return acc;
      }, {});
    });
  };

  const createNewTransfer = (form) => {
    return postTransfers(form)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        const id = r.data.id;
        navigate.push(`/transfers/${id}`);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        throw new Error(e.response.data);
      });
  };

  const fetchNextPage = () => {
    handleFilter({ slug: 'page', value: Number(metadata.page) + 1 });
  };
  const hasNextPage = metadata.page * metadata.limit < metadata.count ?? false;

  const fetchPreviousPage = () => {
    handleFilter({ slug: 'page', value: Number(metadata.page) - 1 });
  };
  const hasPreviousPage = metadata.page > 1 ?? false;

  return (
    <>
      <Page
        title="Traspasos"
        primaryAction={
          <LegacyStack>
            {checkPermission('STOCK:CREATE') && <Button url="/files/transfers/eph">Añadir fichero EPH</Button>}
            {checkPermission('STOCK:CREATE') && <NewTransferModal onAddTransfer={(e) => createNewTransfer(e)} />}
          </LegacyStack>
        }
        backAction={{ content: 'Volver', onAction: () => navigate.goBack() }}
      >
        <Card roundedAbove="sm">
          <FiltersTransfers onFilterChange={handleFilter} initialFilters={currentFilters} />
        </Card>
        <div style={{ height: '10px' }}></div>

        <LegacyCard>
          <ListTransfers
            data={transfers}
            isLoading={isLoading}
            error={error}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            fetchPreviousPage={fetchPreviousPage}
            hasPreviousPage={hasPreviousPage}
          />
        </LegacyCard>
      </Page>
    </>
  );
};

export default Transfers;
